import { RegisterFormModels } from '../../../../models/register-form.models';
import { RegisterFormApiModels } from '../../../../models/api/register-form-api.models';

export class AuthProjector {
  static projectRegisterRequest(
    form: RegisterFormModels.BrokerRegisterForm,
  ): RegisterFormApiModels.RegisterRequest {
    let registerRequest: RegisterFormApiModels.RegisterRequest = {
      firstName: form.prenomResponsable,
      lastName: form.nomResponsable,
      email: form.mail,
      password: form.password1,
      phoneNumber: form.phone,
      mobileNumber: form.mobile,
      civility: form.civility,
    };

    return registerRequest;
  }
}
